import { useMemo } from 'react';
import { PhysicianSupervisee } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useProviderSuperviseesQuery, useStatesQuery } from '@uplift/queries';
import { State } from '@uplift/types';


export type SuperviseesByState = {
  state: State;
  rows: PhysicianSupervisee[];
};


export const useSuperviseesByState = () => {
  const me = useCurrentuser();
  const { data: supervisees = [] } = useProviderSuperviseesQuery(me.id);
  const { data: states = [] } = useStatesQuery({ suspense: true });

  const groupedByState = useMemo<SuperviseesByState[]>(() => {
    const byStateId = new Map<string, PhysicianSupervisee[]>();

    supervisees.forEach((supervisee: PhysicianSupervisee) => {
      const existing = byStateId.get(supervisee.stateId) ?? [];

      existing.push(supervisee);
      byStateId.set(supervisee.stateId, existing);
    });

    return states
      .filter(state => byStateId.has(state.id))
      .map(state => ({ state, rows: byStateId.get(state.id) ?? [] }));
  }, [ supervisees, states ]);

  return {
    supervisees,
    groupedByState,
  };
};
